import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Field } from 'formik';
import classNames from 'classnames';
import { formatPrice } from '@chama/utils/functions/currency';

import { validatePrice } from '../DealerProductsLogic';

import './ProductsFormPriceInput.css';

const strToFloat = str => {
  if (!str) return 0;
  const numbers = str.match(/[0-9]/g);
  if (!numbers) return 0;

  return parseInt(numbers.join(''), 10) / 100;
};

function valueToCurrency(value) {
  const numericValue = parseFloat(value);
  return formatPrice(numericValue);
}

function currencyToValue(currency) {
  return strToFloat(currency).toString();
}

function validateValue(value) {
  const isValidPrice = validatePrice({ price: value });
  const errorMessage = !isValidPrice && (
    <FormattedMessage id="dealer-products.form.errors.price-out-of-range" />
  );
  return errorMessage;
}

export default function PriceInput({ name, disabled, errored }) {
  const className = classNames('ProductsTable__price-input', {
    'ProductsTable__price-input--errored': errored,
  });
  return (
    <Field
      name={name}
      validate={validateValue}
      render={({ field, form }) => {
        return (
          <input
            className={className}
            {...field}
            value={valueToCurrency(field.value)}
            onChange={e => form.setFieldValue(name, currencyToValue(e.currentTarget.value))}
            disabled={disabled}
          />
        );
      }}
    />
  );
}
PriceInput.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  errored: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ../ui-components/components/DealerProducts/Inputs/ProductsFormPriceInput.jsx